/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import FormatEnum from '../../format-enum';

/**
 * Komunikátor formátů aktualizací aplikace pro Ki-Wi Server.
 */
class CommunicatorFormat {
  /**
   * Zpracuje formát aktualizace.
   * @param {string} [value] Formát aktualizace ve formátu, který vrací server.
   * @returns {FormatEnum|null} Formát aktualizace z číselníku.
   */
  static parse(value) {
    let result;
    switch (value) {
      case 'html':
        result = FormatEnum.HTML;
        break;
      case 'ipk':
        result = FormatEnum.IPK;
        break;
      case 'wgt':
        result = FormatEnum.WGT;
        break;
      case 'zip':
        result = FormatEnum.ZIP;
        break;
      default:
        result = null;
    }
    return result;
  }
}

export default CommunicatorFormat;
